export const firstPageHeaderHeight = 132;
export const otherPagesHeaderHeight = 106;
export const pageFooterHeight = 80;
export const paperPlaneId = "loaded_paperplane";
